<div class="courses-body void">
  <span class="glicon-none-course"></span>
  <span class="courses-void__title">{{ 'courses.empty.heading' | translate }}</span>
  <span class="courses-void__subtitle">{{ 'courses.empty.text' | translate }}.</span>
  <gl-button
    *ngIf="!isCreator"
    color-primary
    [text]="'actions.createCourse' | translate"
    (onClick)="onClickOpen(editorUrl)"
  ></gl-button>
</div>
